<template>
    
    <span>
        
        <v-dialog v-model="updateSetpoint"
        width="400"
        persistent
        >

            <template v-slot:activator="{ on }">
                        
                <v-btn 
                v-on="on"
                text>
                    <v-icon class="mr-3">mdi-pencil-outline</v-icon>
                    <span>{{ $t("Update setpoint") }}</span>
                </v-btn>

            </template>

            <v-card>

                <v-card-title>{{ $t("Update setpoint") }}</v-card-title>
                
                <v-divider></v-divider>

                <v-card-text class="pa-4 pb-0">

                    <v-text-field
                        label="Value"
                        outlined
                        v-model="selectedTag.value"
                        v-on:keyup.enter="update();"
                        v-if="selectedTag.type != 'BOOL'"
                    ></v-text-field>

                    <v-switch
                    v-model="isChecked"
                    v-if="selectedTag.type == 'BOOL'"
                    @change="update();"
                    ></v-switch>

                    <v-alert type="info" v-if="isUpdating()">
                        {{ $t("Updating setpoint") }}
                    </v-alert>

                </v-card-text>

                <v-card-actions color="grey" class="pb-4 pt-4">

                    <v-btn :loading="isUpdating()" depressed class="mx-2" color="primary" @click="update();">{{ $t("Update") }}</v-btn>
                    <v-btn outlined class="mx-2" @click="updateSetpoint = false">{{ $t("Cancel") }}</v-btn>

                </v-card-actions>

            </v-card>

        </v-dialog>

    </span>

</template>

<script>

import tagApi from "@/api/tags/Tag" ;

import { mapGetters } from "vuex";

export default {

    computed: {

        ...mapGetters({
            app: 'app/data',
            selected: 'app/selected',
        })

    },

    data () {
        return {
            updateSetpoint: false,
            updating: false,
            showButton: false,
            liveTag: null,
            isChecked: false
        }
    },
    props:{
        selectedTag: {
            type: Object,
            required: true,
        },
    },
    methods: {

        update(){
            
            if(this.selectedTag.value == this.liveTag.value){

                let snackbar = {
                    color: 'red',
                    show: true,
                    text: this.$t('Value has already changed')
                }
                
                this.$store.commit("app/SET_SNACKBAR", snackbar) ;
                
                return ; 
            }

            if(this.selectedTag.type == 'BOOL'){

                if(this.isChecked){
                    this.selectedTag.value = '1';
                }else{
                    this.selectedTag.value = '0';
                }

            }

            this.liveTag.setpoint_status = 'idle' ;

            let _this = this ; 

            this.updating = true ; 

            let data = {
                id: this.selectedTag.id,
                device_id: this.selectedTag.device.id,
                type: 'tags',
                value: this.selectedTag.value
            }

            let api = new tagApi() ;

            api.update_value(data)
            .then(result => {

                _this.updating = false ; 
                console.log(result); 

            }) ;

        },

        isUpdating(){

            if(this.updating && this.liveTag.value != this.selectedTag.value){
                return true ;
            }

            if(this.liveTag.setpoint_status != null && this.liveTag.setpoint_status == 'new'){
                return true ;
            }

            return false ;

        }
        
    },

    created(){

        let _this = this ; 

        if(this.selectedTag.value == '1'){
            this.isChecked = true ;
        }

        this.selectedTag.device.db.collection('tags')
        .doc(this.selectedTag.id).onSnapshot(function(doc) {

            _this.liveTag = doc.data() ;

        });
        
    },

}

</script>